import React from "react";
import styled from "styled-components";
import ResponsiveImage from "../ImageWrapper/ResponsiveImage";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import TitleSection from "../TitleSection/TitleSection";
import SubTitleSection from "../SubTitleSection/SubTitleSection";
import { Row, Col } from "react-bootstrap";

const Craps = () => {
  const { t, i18n } = useTranslation();

  return (
    <CrapsDiv>
      <container-div>
        <TitleSection title={t("etg.craps.title")} />
        <ResponsiveImage
          src={`promotions/craps_header_${i18n.language}.jpg`}
          alt={t("etg.craps.headerImageAlt")}
        />
        <SubTitleSection subTitle={t("etg.craps.subtitle")} />
        <ReactMarkdown>{t("etg.craps.thrillOfCraps")}</ReactMarkdown>
        <ReactMarkdown>{t("etg.craps.howItWorks")}</ReactMarkdown>
        <ReactMarkdown>{t("etg.craps.playersLoveIt")}</ReactMarkdown>
        <Rules>
          <ReactMarkdown>{t("etg.craps.rules")}</ReactMarkdown>
        </Rules>

        <p className="mt-4">
          <strong>{t("etg.craps.helpNotice")}</strong>
        </p>
      </container-div>
    </CrapsDiv>
  );
};

const CrapsDiv = styled.div`
  background: #101010;
  color: var(--white);
  height: fit-content;
  width: 100%;
  & > img:first-child {
    width: 100%;
    height: fit-content;
    vertical-align: middle;
  }
  & > div:last-child {
    padding: 25px 60px;
    width: 100%;
    height: fit-content;
    & > p {
      font-size: 14px;
      color: var(--white);
      margin: 0 0 10px;
    }
    & > h2 {
      font-size: 30px;
      font-weight: 400;
      color: var(--white);
      text-transform: uppercase;
      text-decoration: underline;
      padding: 15px 0;
      line-height: 33px;
      margin: 0;
    }
    & > h3 {
      font-size: 20px;
      font-weight: 700;
      color: var(--white);
      text-transform: uppercase;
      margin: 5px 0px 10px;
    }
    & > p:last-child {
      text-align: center;
      margin-top: 20px;
    }
  }
  ul {
    li {
      padding-bottom: 12px;
    }
  }
  @media screen and (max-width: 991px) {
    & > div:last-child {
      padding: 20px 15px;
      & > h2 {
        font-size: 25px;
      }
    }
  }
`;

const Rules = styled.div`
  ul {
    list-style: decimal;
  }
`;
export default Craps;
